export enum SubscriptionStatus {
    Trial = 'Trial',
    Active = 'Active',
    Pending = 'Pending',
    Expired = 'Expired',
    Canceled = 'Canceled',
}

export const SubscriptionStatusTranslations: Record<SubscriptionStatus, string> = {
    [SubscriptionStatus.Trial]: 'تجريبي',
    [SubscriptionStatus.Active]: 'نشط',
    [SubscriptionStatus.Pending]: 'قيد الانتظار',
    [SubscriptionStatus.Expired]: 'منتهي',
    [SubscriptionStatus.Canceled]: 'ملغي',
};